import React from "react";
import { useNavigate } from "react-router-dom";
import bg from "../assets/background.png";
import Footer from "../components/footer";
import '../styles/coomingSoon.modules.css';
import Seo from '../components/Seo';

export default function ComingSoon() {
  const navigate = useNavigate();

  return (
    <div className="cs_page" style={{ backgroundImage: `url(${bg})` }}>
      <Seo title="Wkrótce dostępne" path="/wkrotce-dostepne" noindex />
      <div className="cs_wrap">
        <div className="cs_card">
          <div className="cs_badge">JUŻ WKRÓTCE</div>

          <h1 className="cs_h1">Ta podstrona jest w budowie</h1>
          <p className="cs_p">
            Dopracowujemy ją dla Ciebie. Wróć za jakiś czas — pojawi się tutaj pełna treść i nowe funkcje.
          </p>

          <div className="cs_divider" />

          <div className="cs_actions">
            <button className="cs_btn cs_btnPrimary" onClick={() => navigate(-1)}>
              Wróć
            </button>
            <button className="cs_btn cs_btnGhost" onClick={() => navigate("/")}>
              Strona główna
            </button>
          </div>

          <div className="cs_hint">
            Jeśli chcesz — napisz do nas przez formularz kontaktowy w zakładce lokalizacji ❤️
          </div>

          <div className="cs_orbs" aria-hidden="true">
            <span className="cs_orb cs_orb1" />
            <span className="cs_orb cs_orb2" />
            <span className="cs_orb cs_orb3" />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
